import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that checks if a file size is within acceptable limits
 * @param maxSizeInMB - Maximum file size in megabytes (default: 10MB)
 * @returns ValidatorFn that validates the file size
 */
export function fileSizeValidator(maxSizeInMB: number = 10): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const file = control.value as File;
    if (!file || !(file instanceof File)) {
      return null;
    }

    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

    if (file.size > maxSizeInBytes) {
      return {
        fileSize: {
          actualSize: file.size,
          maxSize: maxSizeInBytes,
          maxSizeInMB: maxSizeInMB,
        },
      };
    }

    return null;
  };
}
